import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { SystemMessageInfo, SystemMessageSeverity } from '../../core/models';

@Component({
  selector: 'app-system-message-banner',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, ButtonModule],
  template: `
    <div
      class="system-message-banner"
      [ngClass]="bannerClass"
      aria-label="system-message-banner"
      role="alert">
      <div class="flex align-items-center gap-3 flex-1">
        <i [class]="iconClass + ' text-xl'"></i>
        <div class="flex flex-column gap-1">
          <strong>{{ systemMessage.title }}</strong>
          <span>{{ systemMessage.message }}</span>
        </div>
      </div>
      <p-button
        icon="pi pi-times"
        [rounded]="true"
        [text]="true"
        severity="secondary"
        (click)="dismiss.emit()"
        aria-label="Fermer le message">
      </p-button>
    </div>
  `,
  styles: [`
    .system-message-banner {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 9998;
      display: flex;
      align-items: center;
      padding: 0.75rem 1.5rem;
      gap: 1rem;
    }

    .banner-info {
      background-color: var(--blue-50);
      border-bottom: 2px solid var(--blue-500);
      color: var(--blue-900);
    }

    .banner-warning {
      background-color: var(--orange-50);
      border-bottom: 2px solid var(--orange-500);
      color: var(--orange-900);
    }

    .banner-critical {
      background-color: var(--red-50);
      border-bottom: 2px solid var(--red-500);
      color: var(--red-900);
    }
  `]
})
export class SystemMessageBannerComponent {
  @Input() systemMessage!: SystemMessageInfo;
  @Output() dismiss = new EventEmitter<void>();

  get bannerClass(): string {
    const severityMap: Record<number, string> = {
      [SystemMessageSeverity.Info]: 'banner-info',
      [SystemMessageSeverity.Warning]: 'banner-warning',
      [SystemMessageSeverity.Critical]: 'banner-critical',
    };
    return severityMap[this.systemMessage?.severity] ?? 'banner-info';
  }

  get iconClass(): string {
    const iconMap: Record<number, string> = {
      [SystemMessageSeverity.Info]: 'pi pi-info-circle',
      [SystemMessageSeverity.Warning]: 'pi pi-exclamation-triangle',
      [SystemMessageSeverity.Critical]: 'pi pi-exclamation-circle',
    };
    return iconMap[this.systemMessage?.severity] ?? 'pi pi-info-circle';
  }
}
